import { getURLWithParams } from "utils/context";
import { useFetchMxfNestApi, useMxfNestToast } from "hooks";

export const useIbsCbsList = (params = {}) =>
  useFetchMxfNestApi(getURLWithParams("class-ibscbs", params));

export const useRegimeTributarioList = () =>
  useFetchMxfNestApi("regimes-tributarios");

export const useIbsCbsDetail = id =>
  useFetchMxfNestApi(id ? `class-ibscbs/${id}` : null);

export const useIbsCbs = (id = null) => {
  const { onSend, isLoading } = useMxfNestToast();

  const onCreateOrEdit = async data => {
    const endpoint = id ? `class-ibscbs/${id}` : "class-ibscbs";
    const type = id ? "PATCH" : "POST";

    onSend({
      endpoint,
      messageSuccess: id
        ? "Classificação editada com sucesso"
        : "Classificação cadastrada com sucesso",
      messageFail: id
        ? "Não foi possível editar a Classificação"
        : "Não foi possível cadastrar a Classificação",
      data,
      type,
      redirect: !id,
      fieldGetId: "mxf_ibs_id",
      urlRedirect: "/legislacao/class-ibs-cbs/editar",
    });
  };
  return { onCreateOrEdit, isLoading };
};
